import type { MoneyFragment, MoneyInput } from '@/graphql/api'

export function moneyInputOrMoneyFragmentAmount(
    model: MoneyInput | null | undefined,
    bound: MoneyFragment
): number {
    if (model?.amount) {
        return Number(model.amount)
    }

    return Number(bound.amount)
}
